import type * as PdfViewerLib from '@syncfusion/ej2-pdfviewer';

let pdfViewerLib: Promise<typeof PdfViewerLib> | undefined;

// Loads the Syncfusion PDF viewer the first time a document is shown instead of with the app (it is
// several MB). Components must only `import type` from '@syncfusion/ej2-pdfviewer'; a value import
// puts the viewer back into the startup bundle.
// Toolbar is not injected: every viewer using this loader sets enableToolbar = false, yet with the module
// injected Syncfusion still builds the main and annotation toolbars on each appendTo (~4s of blocking work).
// Inject it again if a viewer here ever shows the toolbar.
export function loadPdfViewer(): Promise<typeof PdfViewerLib> {
  pdfViewerLib ??= import('@syncfusion/ej2-pdfviewer')
    .then(lib => {
      lib.PdfViewer.Inject(
        lib.Magnification,
        lib.Navigation,
        lib.LinkAnnotation,
        lib.BookmarkView,
        lib.ThumbnailView,
        lib.Print,
        lib.TextSelection,
        lib.TextSearch,
        lib.Annotation,
        lib.FormFields
      );
      return lib;
    })
    .catch(error => {
      pdfViewerLib = undefined; // let the next attempt retry, e.g. after a network error
      throw error;
    });
  return pdfViewerLib;
}
